import * as React from "react";

import { ElementTrackingPortalStyle } from "./element-tracking-portal-style";
import { APP_ROOT, APP_MODAL_ROOT } from "../../../lib/constants";
import { createPortal } from "react-dom";

function getElementRootOffset(el: HTMLElement): [number, number] {
    let x = 0;
    let y = 0;
    let e: HTMLElement | null = el;
    while (e !== null) {
        x += e.offsetLeft;
        y += e.offsetTop;
        x -= e.scrollLeft;
        y -= e.scrollTop;

        e = e.parentElement;
    }

    return [x, y];
}

interface ChildrenProps {
    readonly rootWidth: number;
    readonly rootHeight: number;
    readonly targetX: number;
    readonly targetY: number;
    readonly targetWidth: number;
    readonly targetHeight: number;
}

interface Props {
    readonly onClose: () => void;
    readonly children: (p: ChildrenProps) => React.ReactNode;
    readonly targetRef: React.RefObject<HTMLElement>;
}

interface State {
    readonly touchStarted: boolean;
}

class ElementTrackingPortal extends React.PureComponent<Props, State> {
    public state: State = {
        touchStarted: false,
    };

    private onClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (this.props.onClose && this.state.touchStarted) {
            this.props.onClose();
        }

        e.stopPropagation();
    };

    private onTouchStart = () => {
        // iOS 12 is dumb and will send a click event right away. It wont however
        // send the touch start so things will be fine if we just ensure that event
        // comes first. Safari!
        this.setState({ touchStarted: true });
    };

    public render(): React.ReactNode {
        const { targetRef, children } = this.props;

        if (targetRef.current === null) return null;

        const appContainer = document.getElementById(APP_ROOT);
        if (appContainer === null) return null;

        const modalRoot = document.getElementById(APP_MODAL_ROOT);
        if (modalRoot === null) return null;

        // const appContainerBounds = appContainer.getBoundingClientRect();
        const [rootX, rootY] = getElementRootOffset(modalRoot);
        const [targetX, targetY] = getElementRootOffset(targetRef.current);

        const width = targetRef.current.clientWidth;
        const height = targetRef.current.clientHeight;
        const left = targetX - rootX;
        const top = targetY - rootY;

        const style: React.CSSProperties = {
            width,
            height,
            left,
            top,
        };

        return createPortal(
            <ElementTrackingPortalStyle
                onClick={this.onClick}
                onTouchStart={this.onTouchStart}
                onMouseDown={this.onTouchStart}>
                <div className="etps-ContentContainer" style={style}>
                    {children({
                        rootWidth: modalRoot.clientWidth,
                        rootHeight: modalRoot.clientHeight,
                        targetX: left,
                        targetY: top,
                        targetWidth: width,
                        targetHeight: height,
                    })}
                </div>
            </ElementTrackingPortalStyle>,
            modalRoot
        );
    }
}

export default ElementTrackingPortal;
